import { useMemo } from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const Chart = loadable(() => import('react-apexcharts'));

const DonutChart = ({ data }) => {
    const series = useMemo(() => !data || data.every((d) => !d) ? [] : data.map((d) => d.value), [data]);

    const options = useMemo(() => ({
        chart: {
            type: 'donut',
        },
        labels: data?.map((d) => d.title),
        dataLabels: {
            enabled: false,
            show: false
        },
        theme: {
            monochrome: {
                enabled: true
            }
        },
        tooltip: {
            enabled: true,
            color: '#FFFFFF'
        },
        noData: {
            text: 'No data',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                fontSize: '18px',
                fontFamily: 'SimplonNorm'
            }
        },
        legend: {
            show: false
        },

    }), [series, data]);

    const dom = useMemo(() => {
        if (!data) {
            return <ContentLoader viewBox='0 0 400 300' height='100%' width='100%'>
                <circle cx='200' cy='110' r='105'/>

                <circle cx='40' cy='240' r='7'/>
                <rect x='55' y='233' rx='2' ry='2' width='140' height='14'/>

                <circle cx='220' cy='240' r='7'/>
                <rect x='235' y='233' rx='2' ry='2' width='140' height='14'/>

                <circle cx='40' cy='270' r='7'/>
                <rect x='55' y='263' rx='2' ry='2' width='140' height='14'/>

                <circle cx='220' cy='270' r='7'/>
                <rect x='235' y='263' rx='2' ry='2' width='140' height='14'/>
            </ContentLoader>;
        }

        return <Chart series={series} options={options} height={160} type='donut'/>;
    }, [series, options, data]);

    return <div className='pieChart w-100'>
        {dom}
    </div>;
};

DonutChart.propTypes = {
    data: PropTypes.object.isRequired,
};

export default DonutChart;
